<template>
    <div class="octolo-footer p-2.5 bg-primary c-white">
        <div class="lg:flex justify-around *:p-2.5">
            <div class="logo-footer text-center lg:w-1/5 md:w-full" style="align-self: center">
                <div class="flex justify-around">
                    <img src="/static/img/logo/Octolo-512.svg" style="height: 100px;" />
                </div>
                <div class="text-xl"><b>{{ gettext("Octolo") }}</b></div>
                <p class="w-4/5 m-auto">{{ gettext("LA PLATEFORME DE GESTION DE VOTRE ACTIONNARIAT") }}</p>
            </div>
            <div class="text-center lg:w-1/5 lg:!text-left">
                <div class="text-lg mb-2.5 ftitle"><b>{{ gettext("À Propos") }}</b></div>
                <span class="text-justify">Octolo.tech la plateforme collaborative française de gestion du secrétariat juridique corporate et de l'actionnariat,
                    conçue pour les dirigeants d'entreprise et d'association, les avocats, les experts-comptables, les bailleurs sociaux et les fonds d'investissement.</span>
                <div class="pt-2.5">
                    <fa icon="home"/>&nbsp;Crédit Municipal de Paris
                </div>
                <div>
                    <fa icon="envelope"/>&nbsp; <a href="mailto:email@example.com">{{ gettext("contact@octolo.tech") }}</a>
                </div>
            </div>
            <div class="text-center lg:w-[15%] lg:text-left">
                <div class="text-lg mb-2.5 ftitle"><b>{{ gettext("Documents légaux") }}</b></div>
                <div class="*:block">
                    <a target="_blank" href="/static/files/MENTIONS_LEGALES_JANV_2024.pdf">{{ gettext("&nbsp;Mentions légales") }}</a>
                    <a target="_blank" href="/privacy/">{{ gettext("&nbsp;Politique de confidentialité") }}</a>
                    <a target="_blank" href="/static/files/CGU.pdf">{{ gettext("&nbsp;Conditions générales") }}</a>
                </div>
                <div class="text-lg mb-2.5 ftitle mt-5"><b>{{ gettext("Nos Services") }}</b></div>
                <div class="*:block">
                    <a target="_blank" href="/contact/meetings/">{{ gettext("&nbsp;AG & Boards") }}</a>
                    <a target="_blank" href="/contact/tkpi/">{{ gettext("&nbsp;Table de capitalisation") }}</a>
                    <a target="_blank" href="/contact/dataroom/">{{ gettext("&nbsp;Dataroom") }}</a>
                </div>
            </div>
            <div class="text-center lg:w-[15%] lg:text-left">
                <div class="text-lg mb-2.5 ftitle"><b>{{ gettext("Raccourcis") }}</b></div>
                <div class="*:block">
                    <a target="_blank" href="/">{{ gettext("&nbsp;Octolo") }}</a>
                    <a target="_blank" href="/habitat/">{{ gettext("&nbsp;Octolo Habitat") }}</a>
                    <a target="_blank" href="https://blog.octolo.tech">{{ gettext("&nbsp;Blog") }}</a>
                    <a target="_blank" :href="contactLink" v-if="!disableContact">{{ gettext("&nbsp;Contactez-nous") }}</a>
                </div>
            </div>
            <!-- <div class="lg:w-1/5">
                <div class="text-lg mb-2.5 ftitle"><b>{{ gettext("Suivez-nous") }}</b></div>
                <a class="twitter-timeline" data-height="200"  href="https://twitter.com/octolo_tech?ref_src=twsrc%5Etfw"></a>
            </div> -->
        </div>
        <hr>
        <div class="*:p-[5px] text-center">
            <a target="_blank" href="/">{{ gettext("Octolo") }}</a>
            <a target="_blank" href="/habitat/">{{ gettext("Octolo Habitat") }}</a>
            <a target="_blank" href="https://blog.octolo.tech">{{ gettext("Blog") }}</a>
            <a onclick="showCookieSettingsModal()" style="cursor: pointer;">{{ gettext("Cookies") }}</a>
            <a target="_blank" :href="contactLink" v-if="!disableContact">{{ gettext("Contact") }}</a>
        </div>
        <div class="social *:m-[5px] text-center text-2xl m-2.5 pb-[50px]">
            <a target="_blank" href="https://twitter.com/octolo_tech"><fa :icon="['fab', 'twitter']" /></a>
            <a target="_blank" href="https://www.linkedin.com/company/octolo-tech"><fa :icon="['fab', 'linkedin']" /></a>
        </div>
    </div>
</template>

<script>
export default {

    // mounted(){
    //     var script = document.createElement('script');
    //     script.src = "https://platform.twitter.com/widgets.js";
    //     script.async = true;
    //     // Add crossorigin and anonymous to the script tag
    //     script.setAttribute('crossorigin', 'anonymous');
    //     document.body.appendChild(script);
    // },
    props: {
        habitat: { type: Boolean },
        disableContact: { type: Boolean },
    },
    computed: {
        contactLink(){
            return this.habitat ? "/contact/habitat/" : "/contact/";
        },
        privacy_pdf(){
            var habitat = "POLITIQUE_DE_CONFIDENTIALITE_HABITAT_JANV_2024.pdf";
            var octolo = "POLITIQUE_DE_CONFIDENTIALITE_JANV_2024.pdf";
            var privacy = this.habitat ? habitat : octolo;
            return "/static/files/" + privacy;
        }
    },
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
.octolo-footer {
    .ftitle {
        color: $octo-secondary;
        border-bottom: 1px solid $octo-secondary;
    }
    a {
        color: $white;
        text-decoration: none;
    }
    a:hover {
        color: $white;
        text-decoration: underline;
    }
    svg {
        // visibility: hidden;
        color: $octo-secondary;
    }
}
</style>
